var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9 6.89998C10.9 9.09998 9.1 10.9 6.9 10.9C4.7 10.9 2.9 9.09998 2.9 6.89998C2.9 4.69998 4.7 2.89998 6.9 2.89998C9.1 2.89998 10.9 4.69998 10.9 6.89998ZM15.4 14.3C15.4 14 15.3 13.7 15.1 13.5L12 10.5C12.7 9.49998 13.1 8.19998 13.1 6.89998C13.1 3.39998 10.3 0.599976 6.8 0.599976C3.3 0.599976 0.5 3.39998 0.5 6.89998C0.5 10.4 3.3 13.2 6.8 13.2C8.1 13.2 9.3 12.8 10.4 12.1L13.5 15.2C13.7 15.4 14 15.5 14.3 15.5C14.9 15.5 15.4 15 15.4 14.3Z"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
